import { useEffect } from "react";
import { useParams } from "react-router-dom";

import Loader from "components/Loader";
import PageNotFound from "pages/404";

import { useLayoutStore } from "@type/store";
import { INIT_USER } from "@type/store/PersonalStore";
import { usePersonalStore } from "@type/store/PersonalStore";
import { queryGetUser } from "api/user/getUser";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

interface PersonalWrapperProps {
  children: React.ReactNode;
}

const PersonalDataWrapper = ({ children }: PersonalWrapperProps) => {
  const { personalSlug } = useParams();
  const isLoading = usePersonalStore((state) => state.isLoading);
  const isDataNotFound = useLayoutStore((state) => state.isDataNotFound);

  const onSetUser = usePersonalStore((state) => state.onSetUser);
  const onSetLoading = usePersonalStore((state) => state.onSetLoading);
  const onSetIsDataNotFound = useLayoutStore(
    (state) => state.onSetIsDataNotFound
  );

  const { isLoading: isLoadingGetUser } = useQueryWithCallbacks({
    queryKey: queryGetUser._key(personalSlug),
    queryFn: () => queryGetUser(personalSlug),
    enabled: !!personalSlug,
    onSuccess: (data) => {
      if (data.idUnique) {
        onSetUser(data);
        onSetIsDataNotFound(false);
        onSetLoading(false);
      } else {
        onSetIsDataNotFound(true);
      }
    },
    onError: () => {
      onSetUser(INIT_USER);
      onSetIsDataNotFound(true);
    },
  });

  useEffect(() => {
    if (personalSlug) {
      if (isLoadingGetUser) {
        onSetUser(INIT_USER);
      }
      onSetLoading(isLoadingGetUser);
    } else {
      onSetIsDataNotFound(false);
      onSetLoading(false);
      onSetUser(INIT_USER);
    }
  }, [
    isLoadingGetUser,
    personalSlug,
    onSetLoading,
    onSetUser,
    onSetIsDataNotFound,
  ]);

  if (isLoading) {
    return <Loader />;
  }

  if (isDataNotFound) {
    return <PageNotFound />;
  }

  return <>{children}</>;
};

export default PersonalDataWrapper;
